import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="not-found-container">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>The page you are looking for does not exist or has been moved.</p>
      <a routerLink="/" class="back-link">Go to Dashboard</a>
    </div>
  `,
  styles: [
    `
      .not-found-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
        text-align: center;
        font-family: sans-serif;
      }
      h1 {
        font-size: 6rem;
        margin: 0;
        color: #5b73e8;
      }
      h2 {
        font-size: 1.5rem;
        color: #495057;
        margin: 0.5rem 0;
      }
      p {
        color: #74788d;
        margin: 1rem 0;
      }
      .back-link {
        padding: 0.75rem 2rem;
        background: #5b73e8;
        color: #fff;
        text-decoration: none;
        border-radius: 4px;
        margin-top: 1rem;
      }
      .back-link:hover {
        background: #4a5ecf;
      }
    `
  ]
})
export class PageNotFoundComponent {}
